import { render, staticRenderFns } from "./TemplateCopyDialog.vue?vue&type=template&id=7ec68a95&scoped=true&"
import script from "./TemplateCopyDialog.vue?vue&type=script&lang=ts&"
export * from "./TemplateCopyDialog.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateCopyDialog.vue?vue&type=style&index=0&id=7ec68a95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec68a95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
